import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-card',
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.scss']
})
export class CardComponent implements OnInit {
    @Input() title: string;
    @Input() footer: string | undefined;
    @Input() image: string | undefined;
    @Input() elevated = true;

  constructor() { }

  ngOnInit(): void {
  }

}
